import { Controller } from "stimulus"

// #1762: elastieken kiezen voor de volgende keer bij een elastiekoefening.
// Per elastiek een aantal met [-] en [+] (0 is niet gekozen); de rij erboven
// laat de keuze direct zien ("2× Rood", "1× Groen").
//
// Twee vormen (zie elastieken/_keuze):
//   direct  een eigen formulier (tablet, sporter-app); Opslaan en Leegmaken
//           versturen het, het antwoord vervangt alleen dit blok
//   veld    velden in een groter formulier (trainingsresultaat); Klaar sluit
//           het venster, opslaan gaat met de rest van de pagina mee
export default class extends Controller {
  static targets = ["aantal", "chips", "paneel", "knopTekst"]
  static values = { direct: Boolean, leeg: String, toevoegen: String, wijzigen: String, max: { type: Number, default: 9 } }

  plus(event) {
    this.stap(event, 1)
  }

  min(event) {
    this.stap(event, -1)
  }

  stap(event, richting) {
    event.preventDefault()
    const veld = this.aantalTargets.find((el) => el.id === event.currentTarget.dataset.veld)
    if (!veld) return
    veld.value = Math.max(0, Math.min(this.maxValue, (parseInt(veld.value, 10) || 0) + richting))
    this.bijwerken()
  }

  bijwerken() {
    const gekozen = []
    this.aantalTargets.forEach((veld) => {
      let aantal = parseInt(veld.value, 10) || 0
      if (aantal < 0 || aantal > this.maxValue) {
        aantal = Math.max(0, Math.min(this.maxValue, aantal))
        veld.value = aantal
      }
      const rij = veld.closest(".ek-keuze")
      if (rij) rij.classList.toggle("is-gekozen", aantal > 0)
      if (aantal > 0) gekozen.push({ aantal, naam: veld.dataset.naam, kleur: veld.dataset.kleur })
    })
    this.tekenChips(gekozen)
  }

  tekenChips(gekozen) {
    if (!this.hasChipsTarget) return
    this.chipsTarget.replaceChildren()
    if (gekozen.length === 0) {
      const leeg = document.createElement("span")
      leeg.className = "ek-leeg"
      leeg.textContent = this.leegValue
      this.chipsTarget.appendChild(leeg)
    }
    gekozen.forEach(({ aantal, naam, kleur }) => {
      const chip = document.createElement("span")
      chip.className = "ek-chip"
      const bol = document.createElement("span")
      bol.className = "ek-bol"
      bol.style.setProperty("--ek-kleur", kleur)
      chip.appendChild(bol)
      chip.appendChild(document.createTextNode(`${aantal}× ${naam}`))
      this.chipsTarget.appendChild(chip)
    })
    if (this.hasKnopTekstTarget) this.knopTekstTarget.textContent = gekozen.length ? this.wijzigenValue : this.toevoegenValue
    this.element.classList.toggle("heeft-keuze", gekozen.length > 0)
  }

  // Het venster helemaal in beeld, ook boven de rustbalk onderaan de tablet
  geopend() {
    if (!this.hasPaneelTarget || !this.paneelTarget.open) return
    const paneel = this.paneelTarget.querySelector(".ca-popover-paneel")
    if (paneel) requestAnimationFrame(() => paneel.scrollIntoView({ block: "nearest", behavior: "smooth" }))
  }

  leegmaken(event) {
    event.preventDefault()
    this.aantalTargets.forEach((veld) => { veld.value = 0 })
    this.bijwerken()
    if (this.directValue) this.versturen()
  }

  // Alleen in de vorm "veld": het venster sluit, opslaan gaat met de pagina mee
  klaar(event) {
    event.preventDefault()
    this.bijwerken()
    if (this.hasPaneelTarget) this.paneelTarget.open = false
  }

  versturen() {
    const formulier = this.element.querySelector("form")
    if (formulier) formulier.requestSubmit()
  }
}
